import React, { useEffect, useState, Suspense, lazy } from 'react';
import './App.css';
import Login from './pages/login';
import ProductList from './pages/productList';
import ProductDialog from './pages/productDialog';
import ShoppingCard from './pages/shoppingCard';
import CheckoutForm from './admin/checkout';
import DetailToCheckout from './admin/detailtocheckout';
import Paymentgetway from './pages/paymentgetway';
import WatchTv from './about/watchtv';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate
} from "react-router-dom";
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import rootStore from './Redux/store';
import { HelmetProvider } from 'react-helmet-async';
import Aboutus from './about/aboutus';
import Privacy from './about/privacy';
import ContactUs from './about/contactus';
import Whatsapp from './admin/whatsapp';
import SellerForm from './admin/sellerform';
import Signin from './admin/signin';
import Offer from './pages/offer';
import Registration from './pages/registration';
import { generateToken, messaging } from './Notification/firebase';
import { onMessage } from 'firebase/messaging';
import toast, { Toaster } from 'react-hot-toast';
import Productpage from './pages/productpage';
import Main from './grocery/main';
import useOnlineStatus from './hooks/useOnlineStatus';
import GroceryList from './grocery/groceryList';
import GroceryDialog from './grocery/productdialog';
import OrganicProductpage from './grocery/productpage';
import  Routes from './router';
import { ScrollToTop } from './router';
import { use } from 'react';
import { notInitialized } from 'react-redux/es/utils/useSyncExternalStore';
import { Capacitor } from '@capacitor/core';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
// import { duration } from 'html2canvas/dist/types/css/property-descriptors/duration';
// store actions data and provided to the app
const store = createStore(
  rootStore,
  applyMiddleware(thunk)
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <ProductList />,
    children: [
      {
        path: "product/:main",
        element: <Offer />,
      },
      {
        path: "product/:main/:subproduct",
        element: <ProductDialog />,
      }
    ],
  },
  {
    path: "amazing-product/:item/:subproduct",
    element: <Productpage />,
  },
  {
    path: "product/shoppingCard",
    element: <ShoppingCard />
  },
  {
    path: "/login",
    element: <Registration />
  },
  {
    path: "/watchtv",
    element: <WatchTv />
  },
  {
    path: "/about",
    element: <Aboutus />
  },
  {
    path: "/privacy",
    element: <Privacy />
  },
  {
    path: "/contact",
    element: <ContactUs />
  },
  {
    path: "/paymentgetway",
    element: <Paymentgetway />,
    errorElement: <ErrorBoundry />
  },
  {
    path: '/signin',
    element: <Signin />
  },
  {
    path: "/savesoil",
    element: <Login />,
  },
  {
    path: "/checkout",
    element: <CheckoutForm />
  },
  {
    path: "personalized-gift/:item/:subproduct",
    element: <Whatsapp />
  },
  {
    path: "/clientproducts",
    element: <SellerForm />
  },
  {
    path: "/detailtocheckout",
    element: <DetailToCheckout />
  },
  {
    path: "/grocery/products",
    element: <Main />
  },
  {
    path: "/list/",
    element: <GroceryList />,
    children: [
      {
        path: "grocery/:main",
        element: <Offer />,
      },
      {
        path: "grocery/:main/:subproduct",
        element: <GroceryDialog />,
      }
    ],
  },
  {
    path: "organic-grocery/:item/:subproduct",
    element: <OrganicProductpage />,
  }
  // {
  //   path:"*",
  //   element:<Navigate to="/" replace/>
  // }
]);

function ErrorBoundry() {
  return (
    <div className='flex flex-col justify-center items-center min-h-screen'>
      <h1 className='text-4xl font-bold'>Oops! Connection lost</h1>
      <p>
        Looks like you're back from payment process or you refresh the page
      </p>
      <a href="/product/all" className="mt-4 mb-8 w-1/2 rounded-md bg-gray-900 px-6 py-3 font-medium text-white">Home</a>
    </div>
  )
}
function App(props) {
  // const [useLocation, setUseLocation] = useState({})
  // const isOnline = useOnlineStatus();

  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    // 2. This code ONLY runs on the client after the first render (hydration).
    // We immediately sync the state with the actual browser status.
    setIsOnline(navigator.onLine);

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  

  // useEffect(() => {
  //   // Only run in web (not iOS/Android Capacitor)
  //   if (Capacitor.getPlatform() === 'web' && 'serviceWorker' in navigator) {
  //     navigator.serviceWorker.addEventListener('message', (event) => {
  //       console.log('Service worker message:', event.data);
  //     });
  //   }
  // }, []);
  const initNotifications = async () => {
    const platform = Capacitor.getPlatform();

    // ✅ Step 1 — Request Permission (shows native popup on Android/iOS)
    const { receive } = await FirebaseMessaging.requestPermissions();

    if (receive !== 'granted') {
      console.warn('Notification permission denied');
      return;
    }
    // ✅ Step 1 — Register SW manually and WAIT for it to be active
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    // ✅ Step 2 — Wait until SW is fully active
    await navigator.serviceWorker.ready;
        // ✅ Step 2 — Get FCM Token
        const { token } = await FirebaseMessaging.getToken({serviceWorkerRegistration: registration, 
        vapidKey: 'BHxb8L5RKKlyVfHRdCBznzfa7Z7pxB-mPXbaUDnxaLFovUxZZuHyEpa3bni3ALXlfAzvjYwQU0Bi9g6Kl1TB7QU' });
        // console.log('FCM Token:', token);
        FirebaseMessaging.addListener('notificationReceived', (event) => {
          toast.info(`🔔 ${event.notification.title}: ${event.notification.body}`);
        });
        if (platform === 'web' && 'serviceWorker' in navigator) {
          navigator.serviceWorker.addEventListener('message', (event) => {
            console.log('Service worker message:', event.data);
          });
        }
  }
  
  useEffect(() => {   
    initNotifications()
    if ('Notification' in window) {
      if(Notification.permission !== "granted"){
        if(Notification.permission !== "denied"){
            toast.custom((t) => (
              <div
              style={{
                padding: '16px',
                color: 'white',
                background: '#363636',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
              className={`${
               t.visible ? 'animate-enter' : 'animate-leave'
               } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
               >
             <div className="flex-1 w-0 p-4">
               <div className="flex items-start">
                 <div className="flex-shrink-0 pt-0.5">
                   <img
                     className="h-10 w-10 rounded-full"
                     src="https://shopnowindia.s3.ap-south-1.amazonaws.com/menwomen_teeshirts_unisex/mint-JI-W-150-154.png"
                     alt="Notification"
                   />
                 </div>
                 <div className="ml-3 flex-1">
                   <p className="text-sm font-medium">
                     Hey User,
                   </p>
                   <p className="mt-1 text-sm">
                   Do you want to enable notification
                   </p>
                 </div>
               </div>
               <div  className="flex border-l border-gray-200">
               <button
               onClick={() =>  generateToken()}
               style={{
                padding: '8px 12px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
                 className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
               >
                 Ok
               </button>
               <button
                  onClick={() => toast.remove(t.id)}
                  style={{
                    padding: '8px 12px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                  }}
                 className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
               >
                 remove
               </button>
             </div>
             </div>
            
           </div>
         ))
         
         // generateToken()
       
         onMessage(messaging, (payload) => {
           // console.log(payload)
           toast(payload.notification.body)
       
           toast(payload.notification.body, {
             duration: 4000,
             position: 'top-center',
       
             // Styling
             style: {},
             className: '',
       
             // Custom Icon
             icon: '👏',
       
             // Change colors of success/error/loading icon
             iconTheme: {
               primary: '#000',
               secondary: '#fff',
             },
       
             // Aria
             ariaProps: {
               role: 'status',
               'aria-live': 'polite',
             },
           })
           // Toast(payload.notification.body)
           // alert(payload.notification.body)
         })
        }
}
    }
  }, [])
  return (<HelmetProvider>
    {isOnline ? (
      <Provider store={store}>
        <div className="App">
          <Toaster />
          {/* <RouterProvider router={router} {...props} /> */}
          <Suspense fallback={<div>Loading page...</div>}>
          <Routes {...props}/>
          </Suspense>
        </div >
      </Provider >
    ) : (
      <div className='flex flex-col justify-center items-center min-h-screen'>
        <h1 className='text-4xl font-bold'>Oops! Connection lost</h1>
        <p>
          Looks like you're offline, please check your internet connection.
        </p>
      </div>
    )}
  </HelmetProvider >
  );
}

export default App;
